<template>
  <transition :name="name" v-on:after-enter="afterEnterAnimation">
    <slot v-if="show"></slot>
  </transition>
</template>
<script>
import { AnimationConstants } from '../Constants';

export default {
  name: 'Animation',
  props: {
    name: {
      type: String,
      required: true,
    },
    time: {
      type: Number,
      required: false,
      default: 1,
    },
    idTag: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      show: false,
      isCustomAnimation: false,
    };
  },
  created() {
    const isCustom = AnimationConstants.ANIMATION[this.name];

    if (isCustom) {
      this.isCustomAnimation = true;
    }
  },
  methods: {
    afterEnterAnimation() {
      if (
        this.isCustomAnimation &&
        this.name === AnimationConstants.ANIMATION.scaleDownVerTop.name
      ) {
        this.afterScaleDownVerTop();
      }
    },
    afterScaleDownVerTop() {
      if (!this.idTag) {
        return;
      }

      const tag = document.getElementById(this.idTag);
      tag.classList.add('scaleDownVerTop-after-enter-custom-class');
    },
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
    }, this.time * 1000);
  },
};
</script>

<style lang="stylus" scoped>
@import '../Styles/custom_animation.styl';
</style>
